import axios from 'axios';

import endpoints from '../define/endpoints';

const wishListUpdate = async (userId, token, entries) => {
  const res = await axios.post(
    `${endpoints.core}/users/${userId}`,
    { wishlist: entries },
    {
      headers: { authorization: `Bearer ${token}` },
    },
    {
      params: { locale: window.freedomeConfig.locale }
    }
  );

  return res.data;
};

export const wishListAddCommand = async ({ entries, listingId }, auth) => {
  // check authentication status
  if (!auth.isAuthenticated) {
    throw new Error(
      'Cannot add entry to wish list, user must be authenticated'
    );
  }

  if (!entries.find((e) => e === listingId)) {
    entries.push(listingId);
    const data = await wishListUpdate(auth.user.id, auth.token, entries);
    return data.wishlist;
  }
};

export const wishListRemoveCommand = async ({ entries, listingId }, auth) => {
  // check authentication status
  if (!auth.isAuthenticated) {
    throw new Error(
      'Cannot remove entry from wish list, user must be authenticated'
    );
  }

  if (entries.find((e) => e === listingId)) {
    entries = entries.filter((e) => e !== listingId);
    const data = await wishListUpdate(auth.user.id, auth.token, entries);
    return data.wishlist;
  }
};
